var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg008Update(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3331 13.8099H16.5708V2.76247H5.52344V0.000244141H19.3331V13.8099Z",
    fill: "#7E6C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 57.9998C13.0158 57.9998 0.000121331 44.9847 0.000121331 29C-0.0226359 21.1563 3.15681 13.6433 8.80366 8.1998L17.0034 0.379883L18.9018 2.38253L10.7198 10.1847C5.61409 15.1099 2.7401 21.9058 2.76235 29C2.76235 43.4655 14.535 55.2381 29 55.2381V57.9998Z",
    fill: "#7E6C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4757 57.9998H38.666V44.1907H41.4277V55.2381H52.4757V57.9998Z",
    fill: "#7E6C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9971 57.6202L39.0982 55.6181L47.2802 47.8159C52.3859 42.8902 55.2604 36.0943 55.2382 29.0001C55.2382 14.5351 43.4655 2.76247 29 2.76247V0.000244141C44.9847 0.000244141 57.9999 13.0159 57.9999 29.0001C58.0231 36.8438 54.8432 44.3568 49.1963 49.8008L40.9971 57.6202Z",
    fill: "#7E6C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6006 39.2363L13.3945 25.0301L15.3451 23.0796L27.6006 35.3351L45.4151 17.5212L47.3656 19.4718L27.6006 39.2363Z",
    fill: "#7E6C54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg008Update);
export default __webpack_public_path__ + "static/media/008-update.bcd25e4449df9e17467193f450b945f5.svg";
export { ForwardRef as ReactComponent };